import { defineMessages } from 'react-intl';

export default defineMessages({
	closePreviewLabel: {
		id: 'fabric.editor.ai.components.closePreviewIconButton.closePreviewLabel.non-final',
		defaultMessage: 'Close preview',
		description: 'Close preview button label and tooltip',
	},
});
